module.exports = __webpack_public_path__ + "img/9788954626477.854ee8f1.jpg";